import Vue from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VueTippy, { TippyComponent } from 'vue-tippy';
import VueRouter from 'vue-router';
import { CardPlugin, LayoutPlugin, ModalPlugin } from 'bootstrap-vue';
import VueObserveVisibility from 'vue-observe-visibility';
import * as Sentry from '@sentry/vue';
import * as NProgress from 'nprogress';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3';

function isProductionHost(): boolean {
    if (process.env.NODE_ENV !== 'production') {
        return false;
    }

    const nonProductionHosts = ['master02.boreal-is.com', 'local.dev.boreal-is.com', 'validation.boreal-is.com'];
    const AWSDevHosts = /^ip-\d+-\d+-\d+-\d+\.boreal-is\.com$/;

    const hostname = window.location.hostname;
    if (
        hostname === 'localhost' ||
        nonProductionHosts.some(pattern => hostname.includes(pattern)) ||
        AWSDevHosts.test(hostname)
    ) {
        return false;
    }

    return true;
}

if (isProductionHost()) {
    Sentry.init({
        Vue,
        release: 'portal@' + process.env.PORTAL_VERSION,
        dsn: process.env.VUE_APP_SENTRY_URL,
        integrations: [new Sentry.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(ModalPlugin);
Vue.use(VueObserveVisibility);
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true,
        explicitRenderParameters: {
            badge: 'bottomleft',
        },
    },
});
Vue.use(VueTippy, {
    theme: 'ims',
});
Vue.component('tippy', TippyComponent);

NProgress.configure({ showSpinner: false, trickleSpeed: 100, speed: 100 });

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
